
import { IProjectDetailSettings } from '@/types/cms'
import { IPrivateDonationForm, IPrivateDonationFormErrors } from '@/types/projects'
import { Component, Vue, Prop } from 'vue-property-decorator'
import EmailInput from '@/components/processing_steps/commons/fields/EmailInput.vue'
import SingleSelectField from '@/components/processing_steps/commons/fields/SingleSelectField.vue'
import CharField from '@/components/processing_steps/commons/fields/CharField.vue'
import CountryField from "@/components/forms/fields/CountryField.vue"
import CurrencyInput from '../CurrencyInput.vue'
import DonationEmailInfoCheckbox from '../hds/DonationEmailInfoCheckbox.vue'
import FormSubHeading from './commons/FormSubHeading.vue'
import RadioButtons from '@/components/processing_steps/commons/fields/RadioButtons.vue'
@Component({
  components: {
    CurrencyInput,
    EmailInput,
    SingleSelectField,
    CharField,
    CountryField,
    DonationEmailInfoCheckbox,
    FormSubHeading,
    RadioButtons
  }
})
export default class DonationForm extends Vue {
  @Prop() privateDonationForm!: IPrivateDonationForm
  @Prop() projectDetailSettings!: IProjectDetailSettings
  @Prop() formErrors!: IPrivateDonationFormErrors
  @Prop() orgaColor!: string
  @Prop() donation_limits!: { min: number, max: number }

  amountValid = false

  terms_of_address = [
    {
      text: this.$gettext("Term of address"),
      value: 1
    },
    {
      text: this.$gettext("Mrs."),
      value: 2
    },
    {
      text: this.$gettext("Mr."),
      value: 3
    }
  ]

  academic_titles = [
    {
      text: this.$gettext('Academic title'),
      value: 1
    },
    {
      text: this.$gettext('Doctor'),
      value: 2
    },
    {
      text: this.$gettext('Professor'),
      value: 3
    }
  ]

  get termsHtmlWithColor () {
    const color = this.orgaColor

    // Add inline color style only if <a> does not already have style or :style
    return this.projectDetailSettings.donationAcceptBoxTextTerms
      ? this.projectDetailSettings.donationAcceptBoxTextTerms.replace(/<a(?![^>]*\b(?:style|:style)\s*=)/g,
          `<a style="color: ${color}"`)
      : ''
  }

  changeAnoymusInInfoMail (value: boolean) {
    this.privateDonationForm.anonymus_in_info_mail = value
  }

  gotoPaymentMethods () {
    this.$emit('goto-payment-methods')
  }

  handleAmountInvalid () {
    this.amountValid = false
    this.$emit('invalid-amount')
  }

  handleAmountValid () {
    this.amountValid = true
    this.$emit('valid-amount')
  }
}
